import DefaultTemplate from "components/templates/DefaultTemplate";
import useLostChild from "hooks/useLostChild";
import useLostItem from "hooks/useLostItem";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import LostChild from "./Child";
import LostItem from "./Item";

const Information = () => {
    const {
        lostItems,
        getLostItems,
        isLoading: isLostItemLoading,
    } = useLostItem();
    if (isLostItemLoading) getLostItems();

    const {
        lostChild,
        getLostChild,
        isLoading: isLostChildLoading,
    } = useLostChild();
    if (isLostChildLoading) getLostChild();

    return (
        <DefaultTemplate
            style={{
                textAlign: "center",
            }}
        >
            <Tabs>
                <TabList>
                    <Tab>迷子</Tab>
                    <Tab>落とし物</Tab>
                </TabList>
                <TabPanel>
                    <LostChild
                        lostChild={lostChild}
                        isLoading={isLostChildLoading}
                    />
                </TabPanel>
                <TabPanel>
                    <LostItem
                        lostItems={lostItems}
                        isLoading={isLostItemLoading}
                    />
                </TabPanel>
            </Tabs>
            <button
                style={{
                    position: "absolute",
                    bottom: "12%",
                    right: "1%",
                }}
                onClick={() =>
                    (window.location.href =
                        "/map?goal=サービスカウンター&goal_floor=5")
                }
            >
                サービスカウンター
                <br />
                へのナビを開始
            </button>
        </DefaultTemplate>
    );
};

export default Information;
